import type { PlayerProfile } from "../types";
import { platform } from "../services/platformService";

interface TitleScreenProps {
  canContinue: boolean;
  profile: PlayerProfile;
  onNewGame: () => void;
  onContinue: () => void;
  onSettings: () => void;
}

export function TitleScreen({ canContinue, profile, onNewGame, onContinue, onSettings }: TitleScreenProps) {
  return (
    <main className="title-screen">
      <section className="title-terminal" aria-labelledby="game-title">
        <div className="title-company">東央データ管理株式会社　夜間監視端末</div>
        <h1 id="game-title">未読：<span>0</span></h1>
        <p className="title-subtitle">MAIL ANOMALY MONITORING SYSTEM</p>
        <div className="title-warning">
          退職済み社員からのメールを確認した場合、絶対に返信せず、異常として報告してください。
        </div>
        <div className="title-menu">
          <button type="button" className="primary-button" onClick={onNewGame}>はじめから</button>
          <button type="button" disabled={!canContinue} onClick={onContinue}>続きから</button>
          <button type="button" onClick={onSettings}>設定</button>
        </div>
        <div className="title-stats">
          <span>勤務記録 {profile.totalRuns}</span>
          <span>発見済み異変 {profile.discoveredAnomalyIds.length}</span>
          <span>確認済み結末 {profile.endings.length}</span>
        </div>
        <footer>VERSION {platform.version} / LOCAL NETWORK ONLY</footer>
      </section>
    </main>
  );
}
